const selectedApprovedAreasReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_SELECTED_APPROVED_AREAS':
      return [...action.payload];
    default:
      return state;
  }
};

export default selectedApprovedAreasReducer;
